import { OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { VideoInfoModalService } from '@core/components/video-info-modal/video-info-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { merge, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { DialogLinkComponent } from './dialog-link/dialog-link.component';
import { TabLinksService } from './tab-links.service';
var TabLinksComponent = /** @class */ (function () {
    function TabLinksComponent(matDialog, tabLinksService, translateService, videoInfoModalService) {
        this.matDialog = matDialog;
        this.tabLinksService = tabLinksService;
        this.translateService = translateService;
        this.videoInfoModalService = videoInfoModalService;
        this.searchControl = new FormControl();
        this.hasLinkedItems = false;
        this.locationLinks = [];
        this.unlinkedEquipments = [];
        this.destroy$ = new Subject();
    }
    TabLinksComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.tabLinksService.unlinkItem$
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (result) {
            _this.clearFormLinks(result);
            _this.populateLinks();
        });
        this.tabLinksService.reloadItem$
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (value) {
            _this.updateFormLinks(value);
            _this.populateLinks();
        });
        this.searchControl.valueChanges
            .pipe(takeUntil(this.destroy$), debounceTime(300))
            .subscribe(function () {
            _this.populateLinks();
        });
        merge(this.maintenanceForm.get('segment').valueChanges, this.maintenanceForm.get('location').valueChanges)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function () {
            _this.populateLinks();
        });
    };
    TabLinksComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    TabLinksComponent.prototype.openDialogLink = function () {
        var _this = this;
        var segment = this.maintenanceForm.get('segment').value;
        var location = this.maintenanceForm.get('location').value;
        if (!segment || !location) {
            return;
        }
        this.matDialog.open(DialogLinkComponent, {
            panelClass: 'field-dialog-860',
            autoFocus: false,
            data: {
                locationId: location.id,
                segmentId: segment.id,
                linkedEquipments: this.maintenanceForm.get('equipments').value,
                linkedSectors: this.maintenanceForm.get('locationSectors').value,
                linkedEnvironments: this.maintenanceForm.get('locationEnvironments').value,
            }
        }).afterClosed().subscribe(function (result) {
            if (result) {
                _this.maintenanceForm.get('equipments').setValue(result.equipments);
                _this.maintenanceForm.get('locationSectors').setValue(result.sectors);
                _this.maintenanceForm.get('locationEnvironments').setValue(result.environments);
            }
            _this.searchControl.setValue('');
            _this.populateLinks();
        });
    };
    TabLinksComponent.prototype.updateFormLinks = function (params) {
        var formValue = this.maintenanceForm.get(params.formControlName);
        var index = formValue.value.findIndex(function (item) { return item.id === params.updatedValue.id; });
        formValue.value[index] = params.updatedValue;
        this.maintenanceForm.get(params.formControlName).setValue(formValue.value);
        if (params.updatedValue.archived) {
            formValue.value.splice(index, 1);
            this.clearFormLinks({
                id: params.updatedValue.id,
                formControlName: params.formControlName
            });
        }
        if (params.formControlName = 'equipments') {
            var hasEnvironmentOnForm = params.updatedValue.locationEnvironment && this.maintenanceForm.get('locationEnvironments').value
                .some(function (environment) { return environment.id === params.updatedValue.locationEnvironment.id; });
            if (params.updatedValue.locationEnvironment && !hasEnvironmentOnForm) {
                formValue.value.splice(index, 1);
                this.clearFormLinks({
                    id: params.updatedValue.id,
                    formControlName: params.formControlName
                });
            }
            var hasSectorOnForm = params.updatedValue.locationSector && this.maintenanceForm.get('locationSectors').value
                .some(function (sector) { return sector.id === params.updatedValue.locationSector.id; });
            if (params.updatedValue.locationSector && !hasSectorOnForm) {
                formValue.value.splice(index, 1);
                this.clearFormLinks({
                    id: params.updatedValue.id,
                    formControlName: params.formControlName
                });
            }
        }
        this.populateLinks();
    };
    TabLinksComponent.prototype.clearFormLinks = function (params) {
        var maintenanceFormValue = this.maintenanceForm.getRawValue();
        var newValue = maintenanceFormValue[params.formControlName].filter(function (item) { return item.id !== params.id; });
        this.maintenanceForm.get(params.formControlName).setValue(newValue);
        if (params.formControlName === 'locationSectors') {
            var environments = maintenanceFormValue.locationEnvironments.filter(function (environment) { return (environment.locationSector.id !== params.id); });
            var equipments = maintenanceFormValue.equipments.filter(function (equipment) { return (!equipment.locationSector || equipment.locationSector.id !== params.id); });
            this.maintenanceForm.get('equipments').setValue(equipments);
            this.maintenanceForm.get('locationEnvironments').setValue(environments);
        }
        if (params.formControlName === 'locationEnvironments') {
            var equipments = maintenanceFormValue.equipments.filter(function (equipment) { return (!equipment.locationEnvironment || equipment.locationEnvironment.id !== params.id); });
            this.maintenanceForm.get('equipments').setValue(equipments);
        }
    };
    TabLinksComponent.prototype.populateLinks = function () {
        this.hasLinkedItems = Boolean(this.maintenanceForm.get('equipments').value.length ||
            this.maintenanceForm.get('locationSectors').value.length ||
            this.maintenanceForm.get('locationEnvironments').value.length);
        var equipments = this.maintenanceForm.get('equipments').value;
        var sectors = this.maintenanceForm.get('locationSectors').value;
        var environments = this.maintenanceForm.get('locationEnvironments').value;
        var searchValue = this.searchControl.value && this.searchControl.value.trim().toLowerCase();
        var _a = this.tabLinksService.linkSectorsEnvironmentsEquipments({
            sectors: sectors,
            environments: environments,
            equipments: equipments
        }), sectorsLinks = _a.sectors, unlinkedEquipments = _a.unlinkedEquipments;
        var locationLinksUnfiltered = this.tabLinksService.formatSectors({
            sectors: sectorsLinks,
            environments: environments,
            equipments: equipments
        });
        var unlinkedEquipmentsUnfiltered = this.tabLinksService.formatUnlinkedEquipments({
            unlinkedEquipments: unlinkedEquipments
        });
        this.locationLinks = this.tabLinksService.filter(locationLinksUnfiltered, searchValue);
        this.unlinkedEquipments = this.tabLinksService.filter(unlinkedEquipmentsUnfiltered, searchValue);
    };
    TabLinksComponent.prototype.openDemonstrationVideoDialog = function () {
        this.videoInfoModalService.open({
            title: this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.FEATURE.INTRO_VIDEO.TITLE'),
            description: this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.FEATURE.INTRO_VIDEO.DESCRIPTION'),
            videoId: 'VQE_FyV8Gf0'
        });
    };
    return TabLinksComponent;
}());
export { TabLinksComponent };
